import { NgModule } from "@angular/core"
import { CommonModule } from "@angular/common"
import { SharedComponentsModule } from "../shared-components/shared-components.module"
import { StudentRoutingModule } from "./student-routing.module"
import { StudentHomepageComponent } from "./student-homepage/student-homepage.component"
import { StudentAssignmentComponent } from "./student-assignment/student-assignment.component"
import { SlidesMenuComponent } from "./student-assignment/slides-menu/slides-menu.component"
import { ResourceModule } from "../resource/resource.module"
import { QuestionWizardComponent } from "./student-assignment/questions-wizard/question-wizard.component"
import { MarkPageDirective } from "./student-assignment/questions-wizard/mark-page.directive"
import { FormsModule } from "@angular/forms"
import { NgSelectModule } from "@ng-select/ng-select"
import { MobileSlidesMenuComponent } from "./student-assignment/mobile-slides-menu/mobile-slides-menu.component"
import { StudentSubjectsGridComponent } from "./student-subjects-grid/student-subjects-grid.component"
import { StudentAssignmentsComponent } from "./student-assignments/student-assignments.component"
import { StudentClassesComponent } from "./student-classes/student-classes.component"
import { StudentAssignmentsResolver } from "./student-assignments.resolver"
import { StudentClassesResolver } from "./student-classes.resolver"

@NgModule({
    declarations: [
        StudentHomepageComponent,
        StudentAssignmentComponent,
        SlidesMenuComponent,
        QuestionWizardComponent,
        MarkPageDirective,
        MobileSlidesMenuComponent,
        StudentSubjectsGridComponent,
        StudentAssignmentsComponent,
        StudentClassesComponent,
    ],
    imports: [
        CommonModule,
        StudentRoutingModule,
        SharedComponentsModule,
        ResourceModule,
        FormsModule,
        NgSelectModule,
    ],
    providers: [StudentAssignmentsResolver, StudentClassesResolver],
})
export class StudentModule {}
